import styled from "styled-components";

export const Title = styled.p`
  color: ${({ color }) => color};
  font-size: ${({ size }) => size};
  margin: ${({ space }) => space};
  font-weight: ${({ weight }) => weight};
`;
